import { API_URL } from "services/config";

// Los archivos subidos (comprobantes, documentación) exigen sesión. Al abrir un
// link o una imagen el navegador no manda el header Authorization, así que la
// API usa una cookie HttpOnly: la de sesión la renueva sola en cada request y
// estas llamadas cubren la app de clientes y el cierre de sesión.
const fileSessionUrl = (accion) => `${API_URL}/rest/file-session/${accion}`;

export const registrarSesionArchivosApp = (token) => {
  if (!token) return Promise.resolve();
  return fetch(fileSessionUrl("app"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token }),
    credentials: "same-origin",
  }).catch(() => {});
};

export const cerrarSesionArchivos = () =>
  fetch(fileSessionUrl("logout"), {
    method: "POST",
    credentials: "same-origin",
    // La página se redirige enseguida: keepalive deja terminar el request.
    keepalive: true,
  }).catch(() => {});
